import { css, type Theme } from '@emotion/react';

export const divider = css`
  padding: 10px 10px 10px 0px;
`;

export const footer = css`
  display: flex;
  align-items: center;
`;

export const connectionsBadge = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: 4px;

  padding: 2px 4px;
  border-radius: 4px;

  background-color: ${theme.colors.warning[100]};
  color: ${theme.colors.gray[600]};
`;
